import React from "react";
import Helmet from "react-helmet";
import { withPrefix } from "gatsby-link";

const Head = props => {
  return (
    <div>
      <Helmet
        title={
          props.source.meta_title[0]
            ? props.source.meta_title[0].text
            : "Bank Information Center"
        }
        meta={[
          {
            name: "description",
            content: props.source.meta_description[0]
              ? props.source.meta_description[0].text
              : "We partner with civil society to spotlight the risks associated with development, and work to improve transparency, accountability, and sustainability at the institutions that drive it."
          },
          { property: "og:type", content: "website" },
          {
            property: "og:title",
            content: props.source.meta_title[0]
              ? props.source.meta_title[0].text
              : "Bank Information Center"
          },
          {
            property: "og:description",
            content: props.source.meta_description[0]
              ? props.source.meta_description[0].text
              : "We partner with civil society to spotlight the risks associated with development, and work to improve transparency, accountability, and sustainability at the institutions that drive it."
          },
          { property: "og:image:width", content: "1200" },
          { property: "og:image:height", content: "630" },
          {
            property: "og:image",
            content: props.source.social_sharing_image
              ? props.source.social_sharing_image.url
              : withPrefix("/opengraph/bic_open-graph_01.png")
          },
          { property: "og:site_name", content: "Bank Information Center" }
        ]}
      />
    </div>
  );
};

export default Head;



// WEBPACK FOOTER //
// ./src/components/Head.js